import { GET_VIDEOS, TOGGLE_VIDEO, REIMPORT_VIDEO } from './actions';
import { SET_VIDEOS, SET_VIDEOS_PAGE, SET_VIDEO_VISIBLE, SET_VIDEOS_QUERY } from './mutations';
import HTTP from './../lib/HTTP';

const state = {
  page: 1,
  data: null,
  query: '',
};

const mutations = {
  [SET_VIDEOS](_state, videos) {
    if (state.data && typeof (state.data) === typeof ([])) {
      _state.data = _state.data.concat(videos);
    }
    else {
      _state.data = videos;
    }
  },
  [SET_VIDEO_VISIBLE](_state, articleId) {
    for (let i = 0; i < _state.data.length; i += 1) {
      if (_state.data[i].id == articleId) {
        _state.data[i].visible = !_state.data[i].visible;
        break;
      }
    }
  },
  [SET_VIDEOS_PAGE](_state, pageNumber) {
    _state.page = pageNumber;
  },
  [SET_VIDEOS_QUERY](_state, query) {
    _state.query = query;
    _state.page = 1;
    _state.data = null;
  }
};

const actions = {
  [GET_VIDEOS](context) {
    return new Promise((resolve, reject) => {
      let url = `videos?page=${context.state.page}`;
      if(context.state.query && context.state.query.trim().length){
        url += `&query=${context.state.query}`;
      }

      HTTP.get(url).then((res) => {
        if (res && res.data && res.data.content) {
          context.commit(SET_VIDEOS, res.data.content);
          context.commit(SET_VIDEOS_PAGE, context.state.page + 1);
        }
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
    });
  },
  [TOGGLE_VIDEO](context, articleId) {
    return HTTP.post(`videos/${articleId}/toggle`);
  },
  [REIMPORT_VIDEO](context, ss_id) {
    return HTTP.post(`videos/${ss_id}/reimport`);
  },
};

export default {
  state,
  mutations,
  actions,
};
